// extracted by mini-css-extract-plugin
export default {"title":"register_title__XyT3L","content":"register_content__zVXER","form":"register_form__ayQ1c"};